import React from "react";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const IOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: "54px",
  height: "26px",
  padding: 0,
  margin: "8px",
  "& .MuiSwitch-switchBase": {
    padding: "4px 5px 3px",
    color: "#CB998D !important",
    "&.Mui-checked": {
      transform: "translateX(26px)",
      color: "#CB998D !important",
      "& + .MuiSwitch-track": {
        backgroundColor: "#fff !important",
        opacity: 1,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#fff",
      border: "6px solid #fff",
    },
  },
  "& .MuiSwitch-thumb": {
    width: "18px",
    height: "18px",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    border: "1px solid #c4c4c4",
    backgroundColor: "#fff !important",
    opacity: "1 !important",
    transition: theme.transitions.create(["background-color", "border"]),
  },
}));

const SwitchBox = ({
  label,
  type,
  value,
  submitStatus,
  required,
  disabled,
  onChange,
}) => {
  return (
    <FormControlLabel
      label={value ? "ON" : "OFF"}
      className={`Custom-SwitchBox ${
        value ? "Custom-SwitchBox-on" : "Custom-SwitchBox-off"
      }`}
      disabled={disabled}
      control={
        <IOSSwitch
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
        />
      }
    />
  );
};

export default SwitchBox;
